var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionBuildings } from "./actionBuildings";
export var TypeBuildingAction;
(function (TypeBuildingAction) {
    TypeBuildingAction["None"] = "None";
    TypeBuildingAction["Construct"] = "Construct";
    TypeBuildingAction["Move"] = "Move";
    TypeBuildingAction["Select"] = "Select";
    TypeBuildingAction["Upgrade"] = "Upgrade";
    TypeBuildingAction["Store"] = "Store";
    TypeBuildingAction["Unstore"] = "Unstore";
})(TypeBuildingAction || (TypeBuildingAction = {}));
var initial = {
    action: TypeBuildingAction.None,
    building: undefined,
    isPlacedTemporarily: false,
    isPlacementValid: true,
    premium: false,
    showBouncingArrow: false,
    type: TypeActionBuildings.None,
};
export var reducerBuildings = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionBuildings.StartPlacement:
        case TypeActionBuildings.StartMove:
        case TypeActionBuildings.StartUpgrade:
        case TypeActionBuildings.SelectBeforePlacement:
        case TypeActionBuildings.StartUnstoreBuilding:
        case TypeActionBuildings.Move:
            return __assign({}, state, { action: action.action, building: action.building, isPlacedTemporarily: false, premium: action.premium, type: action.type });
        case TypeActionBuildings.Rotate:
            return __assign({}, state, { action: action.action, building: __assign({}, action.building, { proto: __assign({}, action.building.proto, { flipped: !action.building.proto.flipped }) }), type: action.type });
        case TypeActionBuildings.CancelPlacement:
        case TypeActionBuildings.CancelMove:
        case TypeActionBuildings.CancelUnstore:
        case TypeActionBuildings.Deselect:
        case TypeActionBuildings.FinishPlacement:
        case TypeActionBuildings.FinishMove:
        case TypeActionBuildings.FinishUnstoreBuilding:
            return initial;
        case TypeActionBuildings.RewriteCenter:
            return __assign({}, state, { buildingCenterCoords: action.buildingCenterCoords });
        case TypeActionBuildings.Select:
            var updateState = __assign({}, state, { action: action.action, building: action.building, showBouncingArrow: false, type: action.type });
            if (action.buildingCenterCoords) {
                updateState.buildingCenterCoords = action.buildingCenterCoords;
            }
            return updateState;
        case TypeActionBuildings.BouncingArrow:
            return __assign({}, state, { showBouncingArrow: action.showBouncingArrow });
        case TypeActionBuildings.Temporary:
            return __assign({}, state, { action: action.action, building: action.building, isPlacedTemporarily: true, isPlacementValid: action.isPlacementValid, premium: action.premium, type: action.type });
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/reducerBuildings.ts
// module id = 83
// module chunks = 3